import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import ReferralsAPI from 'lib/api/referrals'
import { copyToClipboard } from 'lib/utils/common/commonUtils'
import { EVENT } from 'lib/segment/const'
import {
  segmentReferralViewedTrack,
  segmentReferralCodeCopied,
} from 'lib/segment'
import Button from 'components/common/button'
import ReferralBanner from 'components/referral/landing/landing-desktop/banner'
import ReferralHistory from 'components/referral/landing/landing-desktop/history'
import ReferralHowItWork from 'components/referral/landing/landing-desktop/how-it-work'
import ReferralTermsAndConditions from 'components/referral/landing/landing-desktop/tnc'
import Typo from 'constants/typography'
import { BUTTON_TYPES } from 'constants/button'
import { REFERRAL_LOCIZE } from 'components/referral/landing/const'
import { isReferralAvailable } from 'components/referral/utils'
import env from 'config/env'

const ReferralDesktopLandingLoyaltyUser = ({
  customerData,
  internationalization: { country, language, shop },
  ref_type,
  t,
}) => {
  const [referralCode, setReferralCode] = useState('')
  const referralInprogressFlagValue = isReferralAvailable(shop) // 'Referral-Inprogress-20220627'

  const WELCOME_URL = `${env.APP_DOMAIN}/${country}/${language}/referral-welcome`
  const referralCodeLink = referralCode
    ? `${WELCOME_URL}?utm_campaign=referral_${referralCode}`
    : WELCOME_URL
  const shareCodeText = hasLocizeTranslation(
    t,
    REFERRAL_LOCIZE.REFERRAL_SHARE_CODE_TEXT.key,
    REFERRAL_LOCIZE.REFERRAL_SHARE_CODE_TEXT.text,
  )
  const shareCodeTemplate = hasLocizeTranslation(
    t,
    REFERRAL_LOCIZE.REFERRAL_SHARE_CODE_TEMPLATE.key,
    REFERRAL_LOCIZE.REFERRAL_SHARE_CODE_TEMPLATE.text,
  )

  useEffect(() => {
    if (!referralCode && ref_type) {
      segmentReferralViewedTrack(EVENT.referralLPViewed, ref_type)
      ReferralsAPI.getReferralCode(customerData.id_customer).then((result) => {
        setReferralCode(result.referral_code)
      })
    }
  }, [customerData.id_customer, referralCode, ref_type])

  const copyCode = () => {
    const text = `${shareCodeText}\n\n${shareCodeTemplate.replace(
      /%s/g,
      referralCode,
    )}\n${referralCodeLink}`
    copyToClipboard(text)
    segmentReferralCodeCopied(EVENT.referralCodeShared, referralCode)
  }

  return (
    <div className="referral-landing">
      <ReferralBanner>
        <div className="referral-landing-banner__content-code">
          <span className={Typo.body1}>{referralCode}</span>
        </div>
        <Button
          className="referral-landing-banner__content-code-button"
          type={BUTTON_TYPES.primary}
          onClick={copyCode}
        >
          {hasLocizeTranslation(
            t,
            REFERRAL_LOCIZE.REFERRAL_COPY_CODE.key,
            REFERRAL_LOCIZE.REFERRAL_COPY_CODE.text,
          )}
        </Button>
      </ReferralBanner>
      <ReferralHowItWork
        referralInprogressFlagValue={referralInprogressFlagValue}
      />
      {referralInprogressFlagValue && <ReferralHistory />}
      <ReferralTermsAndConditions />
    </div>
  )
}
ReferralDesktopLandingLoyaltyUser.propTypes = {
  customerData: PropTypes.shape({
    id_customer: PropTypes.number,
  }).isRequired,
  internationalization: PropTypes.shape({
    country: PropTypes.string,
    language: PropTypes.string,
    shop: PropTypes.number,
  }).isRequired,
  ref_type: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default compose(
  connect((state) => ({
    customerData: state.auth.customerData,
    internationalization: state.internationalization,
  })),
  withI18next(),
)(ReferralDesktopLandingLoyaltyUser)
